// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components';
import * as Dialog from '@wandb/weave/components/Dialog';
import React from 'react';

import {Analytics} from '../../../services/analytics';
import {useDeleteProjectMembers} from '../hooks';
import {TeamProjectMember} from './utils';

type DeleteProjectMemberModalProps = {
  isOpen: boolean;
  member: TeamProjectMember;
  projectID: string;
  projectName: string;
  projectTeamName: string;
  setIsModalOpen?: (isOpen: boolean) => void;
  handleModalClose(): void;
};

export const DeleteProjectMemberModal = ({
  isOpen,
  member,
  projectID,
  projectName,
  projectTeamName,
  setIsModalOpen,
  handleModalClose,
}: DeleteProjectMemberModalProps) => {
  const {deleteTeamProjectMembers, isLoading} = useDeleteProjectMembers(
    projectTeamName,
    projectName
  );
  const onClickConfirm = async () => {
    await deleteTeamProjectMembers(projectID, [member.id]);
    Analytics.track('Team project interaction', {
      action: 'delete member',
      projectTeamName,
      projectName,
    });
    handleModalClose();
  };
  const onOpenChange = (open: boolean) => {
    if (!isLoading) {
      setIsModalOpen?.(open);
    }
  };
  return (
    <Dialog.Root open={isOpen} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay />
        <Dialog.Content
          className="w-[600px] rounded-lg"
          onInteractOutside={e => e.preventDefault()}>
          <Dialog.Title>Remove {member.name}</Dialog.Title>
          <Dialog.Description className="pt-16">
            Are you sure you want to remove this user? Doing so will remove
            their access to this project.
          </Dialog.Description>
          <div className="mb-8 mt-24 flex items-center">
            <Button
              data-test="delete-all-button"
              variant="destructive"
              size="large"
              onClick={onClickConfirm}>
              Delete
            </Button>
            <Dialog.Close className="ml-8">
              <Button
                className="dark:text-moon-200/100 dark:filter-none hover:dark:text-moon-200"
                variant="ghost"
                size="large">
                Cancel
              </Button>
            </Dialog.Close>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
